import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestMicroRegioes } from './types';

// ACTIONS
import { microRegioesSuccess, microRegioesFailure } from './actions';

function* microRegioes(request: ReducerAction) {
	const { payload }: { payload: IRequestMicroRegioes } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`divisao-equitativa/${CHANNEL}/micro-regioes`,
		payload,
	);

	if (response.status === 200) {
		yield put(microRegioesSuccess(response));
	} else if (response.error) {
		yield put(microRegioesFailure(response.error));
	}
}

export default all([takeLatest(Types.MICRO_REGIOES, microRegioes)]);
